export default __webpack_public_path__ + "static/media/account-limit-exceeded.2af42ed5.png";